import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.function.bind.js";
import _pt from "prop-types";
var _excluded = ["id", "className", "children"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import classnames from 'classnames';
import React from 'react';
/**
 *  Container component to house the footer content of the modal.
 */
export var ModalFooter = function ModalFooter(_ref) {
  var id = _ref.id,
    className = _ref.className,
    children = _ref.children,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var classNames = classnames('lmig-Modal-footer', className);
  if (!children) return null;
  return /*#__PURE__*/React.createElement("footer", _extends({
    id: id,
    className: classNames
  }, otherProps), children);
};
ModalFooter.propTypes = {
  /** Add an optional ID to this element: `<footer class="lmig-Modal-footer">`. If none is provided, a unique ID will be generated. */id: _pt.string,
  /** Add custom classes to this element: `<footer class="lmig-Modal-footer">`. */className: _pt.string,
  /** Any custom markup or components passed into component. Children are rendered in this element: `<footer class="lmig-Modal-footer">`. */children: _pt.oneOfType([_pt.node, _pt.arrayOf(_pt.node)])
};